"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuditLogJSONModel = void 0;
const lodash_1 = __importDefault(require("lodash"));
const GenericStringValueJSONModel_1 = require("src/configeek_assets/src/components/common/jsonModel/GenericStringValueJSONModel");
const AutoSequenceJSONModel_1 = require("src/configeek_assets/src/components/common/jsonModel/AutoSequenceJSONModel");
const GenericNumberValueJSONModel_1 = require("src/configeek_assets/src/components/common/jsonModel/GenericNumberValueJSONModel");
const AuditLogViewJSONModel_1 = require("src/configeek_assets/src/components/loggedIn/content/project/data/audit/model/AuditLogViewJSONModel");
class AuditLogJSONModel {
    constructor(serializedState) {
        this.sequenceJSONModel = new AutoSequenceJSONModel_1.AutoSequenceJSONModel();
        this.keyFilterJSONModel = new GenericStringValueJSONModel_1.GenericStringValueJSONModel();
        this.valueFilterJSONModel = new GenericStringValueJSONModel_1.GenericStringValueJSONModel();
        this.timeFilterJSONModel = new GenericNumberValueJSONModel_1.GenericNumberValueJSONModel();
        this.orderJSONModel = new GenericStringValueJSONModel_1.GenericStringValueJSONModel();
        this.viewJSONModel = new AuditLogViewJSONModel_1.AuditLogViewJSONModel();
        this.reset = () => {
            this.sequenceJSONModel.reset();
            this.keyFilterJSONModel.reset();
            this.valueFilterJSONModel.reset();
            this.timeFilterJSONModel.reset();
            this.orderJSONModel.reset();
            this.viewJSONModel.reset();
        };
        this.overwriteFromSerializedStateString = (serializedState) => {
            let parsed = undefined;
            try {
                if (lodash_1.default.isString(serializedState)) {
                    parsed = JSON.parse(serializedState);
                }
            }
            catch (e) {
            }
            return this.overwriteFromSerializedState(parsed);
        };
        this.overwriteFromSerializedState = (serializedState) => {
            if (serializedState) {
                this.sequenceJSONModel.overwriteFromSerializedState(serializedState.sequence);
                this.keyFilterJSONModel.overwriteFromSerializedState(serializedState.keyFilter);
                this.valueFilterJSONModel.overwriteFromSerializedState(serializedState.valueFilter);
                this.timeFilterJSONModel.overwriteFromSerializedState(serializedState.timeFilter);
                this.orderJSONModel.overwriteFromSerializedState(this.validateOrder(serializedState.order));
                this.viewJSONModel.overwriteFromSerializedState(serializedState.view);
            }
        };
        this.serialize = () => {
            return {
                sequence: this.sequenceJSONModel.serialize(),
                keyFilter: this.keyFilterJSONModel.serialize(),
                valueFilter: this.valueFilterJSONModel.serialize(),
                timeFilter: this.timeFilterJSONModel.serialize(),
                order: this.orderJSONModel.serialize(),
                view: this.viewJSONModel.serialize(),
            };
        };
        this.getSequenceJSONModel = () => this.sequenceJSONModel;
        this.getKeyFilter = () => this.keyFilterJSONModel;
        this.getValueFilter = () => this.valueFilterJSONModel;
        this.getTimeFilter = () => this.timeFilterJSONModel;
        this.getOrder = () => this.orderJSONModel;
        this.getView = () => this.viewJSONModel;
        ////////////////////////////////////////////////
        // Order
        ////////////////////////////////////////////////
        this.getOrderValue = () => this.orderJSONModel.getValue() || "descending";
        this.validateOrder = (value) => {
            switch (value) {
                case "descending":
                case "ascending":
                    return value;
                default:
                    return "descending";
            }
        };
        this.reset();
        this.overwriteFromSerializedState(serializedState);
    }
}
exports.AuditLogJSONModel = AuditLogJSONModel;
////////////////////////////////////////////////
// URL state validator
////////////////////////////////////////////////
AuditLogJSONModel.isModelEmpty = (serializedState) => {
    // if (_.isEmpty(serializedState.keyFilter)) {
    //     return true
    // }
    // if (_.isEmpty(serializedState.valueFilter)) {
    //     return true
    // }
    // if (serializedState.timeFilter == undefined) {
    //     return true
    // }
    return false;
};
AuditLogJSONModel.makeModelStateClean = (serializedState) => {
    return serializedState;
};
AuditLogJSONModel.makeModelStateCleanForTableStatusCheck = (serializedState) => {
    const jsonModel = new AuditLogJSONModel(serializedState);
    jsonModel.getView().reset();
    jsonModel.getSequenceJSONModel().reset();
    if (lodash_1.default.isEmpty(jsonModel.getKeyFilter().getValue())) {
        jsonModel.getKeyFilter().reset();
    }
    if (lodash_1.default.isEmpty(jsonModel.getValueFilter().getValue())) {
        jsonModel.getValueFilter().reset();
    }
    return jsonModel.serialize();
};
